import { merge, Stack, Text } from '@fluentui/react';
import React, { useMemo } from 'react';
import { ResponsiveSize, useResponsiveSize } from '../../../contexts/responsiveContext';

const Interlocutor = (props) => {

    // PROPS
    const {
        email = "",
        label = "Intervenant",
        nom = "",
        portable = "",
        prenom = "",
        tel = "",
    } = props;

    // CONTEXTS
    const { responsiveSize } = useResponsiveSize();

    // MEMOS
    const _fullName = useMemo(() => {
        let infos = [];
        if (!!prenom) infos.push(prenom);
        if (!!nom) infos.push(nom);
        return infos.join(" ");
    }, [nom, prenom]);

    const _styles = useMemo(
        () => {
            let styles = {
                email: {
                    fontSize: 12,
                    lineHeight: "14px"
                },
                fullName: {
                    fontSize: 12,
                    lineHeight: "14px",
                    textTransform: "uppercase",
                },
                label: {
                    root: {
                        color: "#8A8A8A",
                        fontSize: 12,
                        fontWeight: 700,
                        lineHeight: "14px",
                        textAlign: "center",
                        textTransform: "uppercase",
                    },
                },
                phone: {
                    root: {
                        color: "red",
                        fontSize: 12,
                        lineHeight: "14px"
                    }
                },
                outer: {
                    root: {
                        alignItems: "center",
                        background: "#ECECEC",
                        fontSize: 12,
                        gap: 4,
                        justifyContent: "center",
                        padding: "11px 25px",
                    },
                },
            };

            if (responsiveSize >= ResponsiveSize.medium)
                styles = merge(
                    styles,
                    {
                        email: {
                            fontSize: 14,
                            lineHeight: "17px",
                        },
                        fullName: {
                            fontSize: 14,
                            lineHeight: "17px",
                        },
                        label: {
                            root: {
                                fontSize: 14,
                                lineHeight: "17px",
                            },
                        },
                        outer: { root: { width: "49.4%" } },
                        phone: {
                            root: {
                                fontSize: 14,
                                lineHeight: "17px",
                            }
                        },
                    }
                );

            return styles;
        },
        [responsiveSize]
    );

    if (!_fullName && !tel && !portable && !email) return null;
    else return <Stack styles={_styles.outer}>
        <Text styles={_styles.label}>{label}</Text>
        <Text styles={_styles.fullName}>{_fullName || "Contact non communiqué"}</Text>
        <Text styles={_styles.phone}>{tel || portable || "Téléphone non communiqué"}</Text>
        <Text styles={_styles.email}>{email || "Email non communiqué"}</Text>
    </Stack>;

};

export default Interlocutor;